import { rebookingTypeMapping } from '../../common/utils/formatter'

export function isRebooking(type: keyof typeof rebookingTypeMapping | undefined) {
  return rebookingTypeMapping[type] === rebookingTypeMapping.REBOOKING
}

export function isHold(type: keyof typeof rebookingTypeMapping | undefined) {
  return rebookingTypeMapping[type] === rebookingTypeMapping.HOLD
}

export function isActiveXDockShippingPoint(carrier, shippingPointCode) {
  return (
    carrier.xDockScacCodes &&
    carrier.xDockScacCodes.hasOwnProperty(shippingPointCode) &&
    carrier.xDockScacCodes[shippingPointCode].active
  )
}
